<template>
  <b-form @submit.prevent="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b v-text="clientName"></b>
          <div class="d-flex flex-row-reverse">
            <b-button type="button" @click="onSubmit" variant="exitos"
              >Salvar</b-button
            >

            <router-link
              :to="$routeBack('clientes_list')"
              class="btn btn-outline-muted mr-2"
            >
              Voltar
            </router-link>
          </div>
        </div>
      </template>

      <b-tabs
        card
        :pills="isLarge"
        :fill="isLarge"
        :vertical="isLarge"
        class="edit-menu-sidebar"
      >
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>

          <b-row align-v="center" v-if="showTypeSelect">
            <b-col col>
              <b-form-group label="Tipo de Cliente">
                <b-form-radio-group
                  v-model="cliente_type"
                  :options="[
                    {
                      value: 'pj',
                      text: 'Pessoa Jurídica',
                    },
                    {
                      value: 'pf',
                      text: 'Pessoa Física',
                    },
                  ]"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <pessoa-juridica
            v-if="cliente_type == 'pj'"
            ref="pessoa_juridica"
            v-model="cliente.pessoa_juridica"
          />

          <pessoa-fisica
            v-if="cliente_type == 'pf'"
            ref="pessoa_fisica"
            v-model="cliente.pessoa_fisica"
          />

          <TiposInstituicoes
            ref="configuracoes"
            v-model="cliente.configuracoes"
          />

          <b-form-group label="Descrição:">
            <b-form-textarea
              v-model="cliente.descricao"
              placeholder="Descrição"
            >
            </b-form-textarea>
          </b-form-group>
        </b-tab>

        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.endereco"
            />
            Endereço
          </template>
          <Endereco
            v-model="cliente.endereco"
            :cliente_type="cliente_type"
            ref="endereco"
          />
        </b-tab>

        <b-tab v-if="$isAdmin" :disabled="!cliente.id">
          <template #title> Usuários </template>
          <Usuarios ref="usuarios" />
        </b-tab>

        <b-tab :disabled="!cliente.id">
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.planosepagamentos"
            />
            Planos e Pagamentos
          </template>
          <PlanosPagamentos ref="planospagamentos" />
        </b-tab>

        <b-tab v-if="$isConsultor" :disabled="!cliente.id">
          <template #title> Perfis </template>
          <Perfis ref="perfis" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { watcherScreenSize } from "@/mixins/watcherScreenSize";
import cloneDeep from "lodash/cloneDeep";

import PessoaJuridica from "@/components/Form/PessoaJuridica.vue";
import PessoaFisica from "@/components/Form/PessoaFisica.vue";
import Endereco from "./Form/Endereco.vue";
import PlanosPagamentos from "./Form/PlanosPagamentos.vue";
import TiposInstituicoes from "./Form/TiposInstituicoes.vue";
import Usuarios from "./Form/Usuarios.vue";
import Perfis from "./Form/Perfis.vue";
import { safeArray } from "@/helpers/functions/ArrayHelpers";

export default {
  mixins: [validationMixin, watcherScreenSize()],
  components: {
    PessoaJuridica,
    PessoaFisica,
    Usuarios,
    Endereco,
    PlanosPagamentos,
    TiposInstituicoes,
    Perfis,
  },
  props: {
    new: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    cliente_type: "pj",
    validations: {
      dados_basicos: true,
      endereco: true,
      configuracoes: true,
      planosepagamentos: true,
    },
  }),
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("clientes", ["cliente", "error"]),
    isLarge() {
      return this.$isOneOfTypeSize(["md", "lg", "xl"]);
    },
    showTypeSelect() {
      return this.new;
    },
    clientType() {
      const dictionary = {
        pessoa_fisica: "pf",
        pessoa_juridica: "pj",
      };
      return dictionary[this.cliente?.tipo_pessoa] || "pf";
    },
    clientName() {
      if (this.cliente_type == "pj" && this.cliente.pessoa_juridica) {
        return this.cliente.pessoa_juridica.nome;
      }

      return this.cliente.pessoa_fisica.nome;
    },
    $isAdmin() {
      return safeArray(this.user.roles).find(
        (elem) => elem === "super-admin" || elem.name === "super-admin"
      );
    },
    $isConsultor() {
      return safeArray(this.cliente?.clientePlanos).find(
        (plano) => plano.plano_exitos?.plano_consultor === 1
      );
    },
  },
  methods: {
    ...mapActions("clientes", ["ActionSave", "ActionNewCliente"]),
    async onSubmit() {
      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
        return;
      }
      const source = cloneDeep(this.cliente);
      try {
        if (this.cliente_type == "pj") {
          delete source["pessoa_fisica"];
        } else {
          delete source["pessoa_juridica"];
        }

        Reflect.set(source, "planos", source.clientePlanos);

        const result = await this.ActionSave(source);

        if (this.error && this.error.body) {
          this.$notifications.addNotification({
            message: this.error.body.error,
            icon: "exclamation-triangle",
            type: "danger",
          });
          return;
        }

        this.$emit("saved", this.cliente.id);

        this.$notifications.addNotification({
          message: "Registro salvo com sucesso",
          type: "success",
        });
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao salvar",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    isValid() {
      if (this.cliente_type == "pj") {
        this.validations.dados_basicos = this.$refs.pessoa_juridica.isValid();
      } else if (this.cliente_type == "pf") {
        this.validations.dados_basicos = this.$refs.pessoa_fisica.isValid();
      }
      this.validations.configuracoes = this.$refs.configuracoes.isValid();
      this.validations.endereco = this.$refs.endereco.isValid();
      return Object.values(this.validations).every(Boolean);
    },
  },
  watch: {
    "cliente.id": {
      deep: true,
      handler: function (val) {
        const dictionary = {
          pessoa_fisica: "pf",
          pessoa_juridica: "pj",
        };

        this.cliente_type = dictionary[this.cliente?.tipo_pessoa] || "pf";
      },
    },
  },
  mounted() {},
};
</script>

<style></style>
